(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // Lazy load iframes with data-src
    const lazyIframes = document.querySelectorAll('iframe[data-src]');
    
    if ('IntersectionObserver' in window) {
      const iframeObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const iframe = entry.target;
            iframe.src = iframe.dataset.src;
            iframe.removeAttribute('data-src');
            observer.unobserve(iframe);
          }
        });
      }, {
        rootMargin: '50px' // Start loading 50px before iframe enters viewport
      });
      
      lazyIframes.forEach(iframe => iframeObserver.observe(iframe));
    } else {
      // Fallback for browsers without IntersectionObserver
      lazyIframes.forEach(iframe => {
        iframe.src = iframe.dataset.src;
        iframe.removeAttribute('data-src');
      });
    }
    
    const heroFullscreenButtons = document.querySelectorAll('.hero-fullscreen-button');
    
    heroFullscreenButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const mediaContainer = this.closest('.hero-banner__media--video');
        const video = mediaContainer.querySelector('video');
        const iframe = mediaContainer.querySelector('iframe');
        
        // For HTML5 video
        if (video) {
          // iOS Safari uses webkitEnterFullscreen instead of webkitRequestFullscreen
          if (video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
          } else if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
          } else if (video.mozRequestFullScreen) {
            video.mozRequestFullScreen();
          } else if (video.msRequestFullscreen) {
            video.msRequestFullscreen();
          }
        }
        // For iframe (YouTube/Vimeo)
        else if (iframe) {
          if (iframe.requestFullscreen) {
            iframe.requestFullscreen();
          } else if (iframe.webkitRequestFullscreen) {
            iframe.webkitRequestFullscreen();
          } else if (iframe.mozRequestFullScreen) {
            iframe.mozRequestFullScreen();
          } else if (iframe.msRequestFullscreen) {
            iframe.msRequestFullscreen();
          }
        }
      });
    });
  });
})();
